module.exports = __webpack_public_path__ + "media/listing/bunny-placeholder-341ed3eb.png";